import { EntityBase, Var } from "addeus-common-library/stores/firestore";
import { EntityArray } from "addeus-common-library/stores/firestore/entity";
import moment from "moment-with-locales-es6";

const days: moment[] = [];
const start = moment().startOf("week");
const end = moment().endOf("week");
for (let day = start; day.isBefore(end) === true; day.add(1, "day")) {
    days.push({
        label: day.format("dddd"),
        value: day.day(),
    });
}

export class BusinessHour extends EntityBase {
    @Var(Array.of(Number))
    daysOfWeek: number[] = EntityArray([0, 1, 2, 3, 4, 5, 6]);

    @Var(moment)
    specificDate: moment | undefined;

    @Var(String)
    startTime: string = "00:00";

    @Var(String)
    endTime: string = "23:59";
}
